import { z } from 'zod';
/** `{ en, bg }` with both sides present (may be empty strings). */
export const zTranslatable = z.object({
    en: z.string().default(''),
    bg: z.string().default(''),
});
/**
 * Bulgarian is the authored primary language in the current admin UI, so `bg`
 * is required and `en` is optional (filled by the AI-translate step or by hand).
 */
export const zTranslatableBgRequired = z.object({
    bg: z.string().min(1, 'Bulgarian text is required'),
    en: z.string().default(''),
});
export const zTranslatableBothRequired = z.object({
    bg: z.string().min(1, 'Bulgarian text is required'),
    en: z.string().min(1, 'English text is required'),
});
//# sourceMappingURL=translatable.js.map